import React from "react";
import { sprintf } from "sprintf-js";
import { digestMessage } from "../Helper";

class TestAuthorizationForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      garages: [],
      readers: [],
      credentialTypes: [
        { value: "rfid", name: "RFID" },
        { value: "card", name: "FOB" },
        { value: "phone", name: "Phone" },
        { value: "mobile", name: "Mobile" },
        { value: "barcode", name: "QR/Ticket" },
        { value: "lpr", name: "LPR Credential" },
        { value: "lpr_plate", name: "LPR Plate" },
      ],
      credentialTypeSelected: "rfid",
      garageSelected: "",
      readerSelected: "",
      formTag: "",
      credential: "",
      loading: false,
      errorMessage: "",
      resultMessage: "",
      fetchedMobileDevices: [],
      response: null,
      confirm: false,
      lprPlate: ""
    };

    this.handleGarageSelectChange = this.handleGarageSelectChange.bind(this);
    this.handleReaderSelectChange = this.handleReaderSelectChange.bind(this);
    this.handleCredentialTypeChange = this.handleCredentialTypeChange.bind(this);
    this.handleLprPlateChange = this.handleLprPlateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    fetch("/garages.json")
      .then((response) => response.json())
      .then((data) => {
        this.setState({ ...this.state, garages: data });
        // If there is a garage_id in the query params, select that garage and fetch its readers
        let parts = new String(window.location).split("?garage_id=")
        let garageId = parseInt(parts[1]);
        if (parts.length > 1) {
          let garageSelected = this.state.garages.find(g => g.id === garageId);
          this.fetchReaders(garageId);          
          this.setState({ ...this.state, garageSelected });
        }
      });
  }

  fetchReaders(garageId) {
    fetch(`/readers.json?garage=${garageId}`)
      .then((response) => response.json())
      .then((data) => this.setState({ ...this.state, readers: data }));
  }

  handleCredentialChange = (e) => this.setState({ ...this.state, credential: e.target.value });
  handleLprPlateChange = (e) => this.setState({ ...this.state, lprPlate: e.target.value });
  handleFormTagChange = (e) => this.setState({ ...this.state, formTag: e.target.value });
  handleCredentialTypeChange = (e) =>
    this.setState({ ...this.state, credentialTypeSelected: e.target.value });

  handleGarageSelectChange(e) {
    const garageSelected = this.state.garages.find((g) => g.id === parseInt(e.target.value)) || "";
    this.setState({ ...this.state, garageSelected });

    if (e.target.value !== "") {
      this.fetchReaders(e.target.value);
    } else {
      this.setState({ ...this.state, readers: [] });
    }
  }

  handleReaderSelectChange(e) {
    const readerSelected = this.state.readers.find((r) => r.id === parseInt(e.target.value)) || "";
    this.setState({ ...this.state, readerSelected });
  }

  fetchMobileAuthorization() {
    fetch("/api/v1/mobile_devices/search", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token token="${this.props.api_key}"`,
      },
      body: JSON.stringify({ search: { tag: this.state.formTag.trim() } }),
    })
      .then((response) => {
        if (![200, 422].includes(response.status)) {
          console.error("Error fetching mobile authorization: "+response.status+": "+response.statusText);
          throw Error("Site app server error with authorization: "+response.status+": "+response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.length > 0) {
          console.log("Fetch mobile devices gave us: "+JSON.stringify(data));
          this.setState({ ...this.state, errorMessage: "", fetchedMobileDevices: data }, () => {
            this.fetchAuthorization();
          });
        } else {
          this.setState({
            ...this.state,
            errorMessage: "No mobile device connected to that Plate",
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({ ...this.state, loading: false, errorMessage: ""+error });
      });
  }

  async buildParams() {
    let theParams = {
      detection: {
        test_auth: true,
        reader: {
          name: this.state.readerSelected.name,
          mac_address: this.state.readerSelected.mac_address,
        },
        tags: [
          {
            rfid: `C033 ${this.state.credential.trim()}`,
            rssi: 3000,
          },
        ],
      },
    };
    console.log("building params with confirm set to  "+this.state.confirm);
    theParams.detection.confirm = this.state.confirm;
    if (this.state.confirm) {
      theParams.detection.test_auth = false;
    }
    theParams.detection.lpr_plate = this.state.lprPlate;

    if (this.state.credentialTypeSelected === "mobile") {
      // here we need to generate the first 4 letters
      const addressHex = sprintf("%08X", this.state.fetchedMobileDevices[0].id);
      const newHashSecret = this.state.fetchedMobileDevices[0].new_hash_secret;
      const gateOpenCount = "00";
      var vehicle_index = -1;

      const mrvs = this.state.fetchedMobileDevices[0]["member_record"]["member_records_vehicles"];
      console.log("looping over mrvs: "+mrvs.count+" of them")
      for (var i = 0; i < mrvs.length; i++) {
        console.log("mrv: "+JSON.stringify(mrvs[i]));
        const mrv = mrvs[i];
        const vehicle = mrv["vehicle"];        
        if (vehicle.plate === this.state.formTag.trim()) {
          console.log("match")
          vehicle_index = mrv.vehicle_index;
          console.log("vehilce_index is now "+vehicle_index);
          break;
        }
        else {
          console.log("no match for "+vehicle.plate+" vs "+this.state.formTag.trim());
        }
      }
      
      const originalString = `${newHashSecret}${addressHex}${gateOpenCount}`;
      console.log("originalString: "+originalString);
      const encodedString = await digestMessage(originalString);

      theParams.detection.tags[0].vehicle_index = vehicle_index;
      theParams.detection.tags[0].type = "ble";
      theParams.detection.tags[0].rfid = sprintf("%08X", this.state.fetchedMobileDevices[0].id);
      theParams.detection.tags[0].utid = `${encodedString.substring(0, 4)} 00`;
    }

    if (this.state.credentialTypeSelected === "card") {
      theParams.detection.tags[0].type = "card";
      theParams.detection.tags[0].rfid = this.state.credential.trim();
    }

    if (this.state.credentialTypeSelected === "phone") {
      theParams.detection.tags[0].type = "phone";
      theParams.detection.tags[0].rfid = this.state.credential.trim();
    }
    if (this.state.credentialTypeSelected === "barcode") {
      theParams.detection.tags[0].type = "barcode";
      theParams.detection.tags[0].rfid = this.state.credential.trim();
    }

    if (this.state.credentialTypeSelected === "lpr") {
      theParams.detection.tags[0].type = "lpr";
      theParams.detection.tags[0].rfid = this.state.credential.trim();
      theParams.detection.lpr_plate = this.state.credential.trim();
    }

    if (this.state.credentialTypeSelected === "lpr_plate") {

      theParams.detection.tags = [];
      theParams.detection.lpr_plate = this.state.credential.trim();
    }

    console.log("Final params to be sent: "+JSON.stringify(theParams));

    return theParams;
  }

  async fetchAuthorization() {
    const params = await this.buildParams();

    this.setState({ ...this.state, loading: true, response: null }, () => {
      fetch("/detections", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token token="${this.props.api_key}"`,
        },
        body: JSON.stringify(params),
      })
        .then((response) => {
          if (![200, 422].includes(response.status)) {
            throw Error("Site app server error with authorization: "+response.status);
          }
          return response;
        })
        .then((response) => response.json())
        .then((data) => {
          if (this.state.confirm) {
            var message = "New tranisit created for "+this.state.garageSelected.name+" on lane "+this.state.readerSelected.name;
            setTimeout(() => {
              alert(message);
            }, 200);
          }

          this.setState({ ...this.state, errorMessage: "", response: data, loading: false, confirm: false  });
        })
        .catch((error) => {
          console.error(error);
          this.setState({ ...this.state, loading: false, errorMessage: ""+error, confirm: false });
        });
    });
  }

  async handleSubmit(e) {
    e.preventDefault();

    // Look up mobile device from email, new params
    if (this.state.credentialTypeSelected === "mobile") {
      this.fetchMobileAuthorization();
    } else {
      this.fetchAuthorization();
    }
  }

  render_response(response) {  
    console.log("response: "+JSON.stringify(response))
    var authorized = <h2 className="authorized">Authorized</h2>
    if (response.rfid == null) {
      authorized = <h2 className="not-authorized">Not Authorized</h2> 
    }
    if (response.permit_id != null) {
      authorized = <h2 className="authorized">Authorized by permit {response.permit_id}</h2> 
    }
    
    var permitHeader = ( <h3>No Permits</h3> ) 
    if (response.reasoning.permit_reasons.length > 0) {
      permitHeader = ( <h3>Evaluated Permits:</h3> ) 
    }
    var permitRows = [];
    for (var i = 0; i < response.reasoning.permit_reasons.length; i++) {
      var className = response.reasoning.permit_reasons[i].reason == "permit_active_and_unused" ? "authorized" : "not-authorized"
      permitRows.push ( <p key={i} className={className}>{response.reasoning.permit_reasons[i].permit_identifier}: {response.reasoning.permit_reasons[i].reason}</p> )
    }
    var hourlyInfo = null;
    var hourlyHeader = ( <p>No hourly information applicable</p> );
    if (response.reasoning.hourly_info) {
      hourlyHeader = ( <h3>Hourly Details:</h3> )
      hourlyInfo = (
        <div>
        <p className={response.reasoning.hourly_info.hourly_allowed ? "authorized" : "not-authorized"}>Hourly Enabled for Garage: {response.reasoning.hourly_info.hourly_allowed ? "YES" : "NO"}</p>
        <p className={response.reasoning.hourly_info.sufficient_funds ? "authorized" : "not-authorized"}>Sufficient Funds: {response.reasoning.hourly_info.sufficient_funds ? "YES" : "NO"}</p>
        <p className={response.reasoning.hourly_info.handsfree_autopay ? "authorized" : "not-authorized"}>Handsfree Autopay Enabled: {response.reasoning.hourly_info.handsfree_autopay ? "YES" : "NO"}</p>
        <p>Price: ${response.reasoning.hourly_amount}</p>
        <p>Duration (minutes): {response.reasoning.hourly_duration}</p>
        </div>
      )
    }
    var correlationHeader = ( <h3>Correlation Info:</h3> )
    var correlationRows = [];
    correlationRows.push(<p key={0}>Correlated entry: {response.reasoning.correlated_entry ? response.reasoning.correlated_entry : "None"}</p>)        
    correlationRows.push(<p key={1}>Correlated By: {response.reasoning.correlated_by}</p>) 
    if (response.reasoning.rejected_correlation_reasons != null && response.reasoning.rejected_correlation_reasons.length > 0) {
      correlationRows.push(<p key={2}>Rejected correlation candidates and reasons:</p>)        
      for (var i = 0; i < response.reasoning.rejected_correlation_reasons.length; i++) {
        correlationRows.push ( <p key={i+3}>* {response.reasoning.rejected_correlation_reasons[i].detected_at}: {response.reasoning.rejected_correlation_reasons[i].reason}</p> )
      }
    }

    return (
      <div>
        {authorized}
        <p>{response['reason']}</p>
        {permitHeader}
        {permitRows}
        {hourlyHeader}
        {hourlyInfo}
        {correlationHeader}
        {correlationRows}
      </div>
    )
  }

  render() {
    return (
      <div>
        {this.state.response && this.render_response(this.state.response)}
        {this.state.errorMessage && (
          <div className="alert alert-danger">{this.state.errorMessage}</div>
        )}
        <form onSubmit={this.handleSubmit}>
          <div className="form-group">
            <select
              onChange={this.handleGarageSelectChange}
              value={this.state.garageSelected.id || ""}
              className="form-control margin-fix"
              data-testid="garage-select"
            >
              <option value="" defaultValue>
                Select Garage
              </option>
              {this.state.garages.map((garage) => (
                <option key={garage.id} name="garage" value={garage.id}>
                  {garage.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <select
              onChange={this.handleReaderSelectChange}
              value={this.state.readerSelected.id || ""}
              className="form-control margin-fix"
            >
              <option value="" defaultValue>
                All Readers
              </option>
              {this.state.readers.map((reader) => (
                <option key={reader.id} name="reader" value={reader.id}>
                  {reader.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            {this.state.credentialTypes.map((credentialType) => {
              return (
                <label key={credentialType.value} className="radio-inline">
                  <input
                    onChange={this.handleCredentialTypeChange}
                    value={credentialType.value}
                    name="credential_type"
                    type="radio"
                    checked={this.state.credentialTypeSelected === credentialType.value}
                  />
                  {credentialType.name}
                </label>
              );
            })}
          </div>

          {this.state.credentialTypeSelected === "rfid" && (
            <div className="form-group">
              <input
                value={this.state.credential}
                onChange={this.handleCredentialChange}
                placeholder="C033 XXXX"
                type="text"
                name="credential"
                className="form-control"
              />
            </div>
          )}

          {this.state.credentialTypeSelected === "phone" && (
            <div className="form-group">
              <input
                value={this.state.credential}
                onChange={this.handleCredentialChange}
                placeholder="+1XXXYYYZZZZ"
                type="text"
                name="credential"
                className="form-control"
              />
            </div>
          )}

          {this.state.credentialTypeSelected === "barcode" && (
            <div className="form-group">
              <input
                value={this.state.credential}
                onChange={this.handleCredentialChange}
                placeholder="Enter full or human readable form (COMxx-xxxxxxxx or xx xxxx or S yyyy zzzz or V yyyy zzzz or P yy zzzz)"
                type="text"
                name="credential"
                className="form-control"
              />
            </div>
          )}

          {(this.state.credentialTypeSelected === "lpr" || this.state.credentialTypeSelected === "lpr_plate") && (
            <div className="form-group">
              <input
                value={this.state.credential}
                onChange={this.handleCredentialChange}
                placeholder="Enter license plate number wihtout state, spaces or dashes (e.g. ABC1234)"
                type="text"
                name="credential"
                className="form-control"
              />
            </div>
          )}

          {this.state.credentialTypeSelected === "card" && (
          
            <div className="form-group">
              <input
                value={this.state.formTag}
                onChange={this.handleFormTagChange}
                placeholder="card or fob id"
                type="text"
                name="credential"
                className="form-control"
              />
            </div>                   
          )}

          {this.state.credentialTypeSelected === "mobile" && (
            <div className="form-group">
              <p>Warning: When using this tool to check a mobile authorization, it will never allow a vehicle-specific permit.  These permits will always show "incorrect vehicle for permit code 09" until this tool is augment to support such permits on mobile</p>
              <input
                value={this.state.formTag}
                onChange={this.handleFormTagChange}
                placeholder="plate number"
                type="text"
                name="email"
                className="form-control"
              />
            </div>
          )}          

          <button
            className="btn btn-primary"
            onClick={() => {{this.setState({ ...this.state, confirm: false })}}}
            disabled={!(this.state.garageSelected && this.state.readerSelected)}
          >
            Test Authorization
          </button>

          <hr/>
          <p>After you have completed a test authorization above, you may use the form below to make this into a transit for the garage, optionally supplying a captured LPR to go with the transit.</p>

          <div className="form-group">
            <input
              value={this.state.lprPlate}
              onChange={this.handleLprPlateChange}
              placeholder="XYZ1234"
              type="text"
              name="LPR Plate"
              className="form-control"
            />
            <br/>
            <button
              className="btn btn-primary"
              onClick={() => {{this.setState({ ...this.state, confirm: true })}}}
              disabled={!(this.state.garageSelected && this.state.readerSelected)}
            >
              Create Transit
            </button>          
          </div>

        </form>
      </div>
    );
  }
}

export default TestAuthorizationForm;
